import { makeActionCreator } from '../../config/store/utils'
import { getBuyer, getBuyerKPIs } from '../../services/buyers'

export const GET_BUYER = 'GET_BUYER'
export const GET_BUYER_ERROR = 'GET_BUYER_ERROR'
export const GET_BUYER_SUCCESS = 'GET_BUYER_SUCCESS'
export const onGetBuyer = makeActionCreator(GET_BUYER)
export const onGetBuyerError = makeActionCreator(GET_BUYER_ERROR, 'payload')
export const onGetBuyerSuccess = makeActionCreator(GET_BUYER_SUCCESS, 'payload')
export const onGetBuyerThunk = payload => async dispatch => {
  dispatch(onGetBuyer())

  try {
    const response = await getBuyer({ id: payload.id })

    if (response.data.success !== 'OK') {
      return dispatch(onGetBuyerError({ error: response.data.errores }))
    }

    const buyer = response.data.payload.find(item => parseInt(item.idEntity, 10) === parseInt(payload.id, 10)) || {}

    return dispatch(
      onGetBuyerSuccess({
        idEntity: buyer?.idEntity,
        name: buyer?.name,
        sector: buyer?.sector
      })
    )
  } catch (error) {
    return dispatch(onGetBuyerError({ error }))
  }
}

export const GET_BUYER_KPIS = 'GET_BUYER_KPIS'
export const GET_BUYER_KPIS_ERROR = 'GET_BUYER_KPIS_ERROR'
export const GET_BUYER_KPIS_SUCCESS = 'GET_BUYER_KPIS_SUCCESS'
export const onGetBuyerKPIs = makeActionCreator(GET_BUYER_KPIS)
export const onGetBuyerKPIsError = makeActionCreator(GET_BUYER_KPIS_ERROR, 'payload')
export const onGetBuyerKPIsSuccess = makeActionCreator(GET_BUYER_KPIS_SUCCESS, 'payload')
export const onGetBuyerKPIsThunk = payload => async dispatch => {
  dispatch(onGetBuyerKPIs())

  try {
    const { data } = await getBuyerKPIs({ id: payload.id, year: payload.year })

    if (data.success !== 'OK') {
      return dispatch(onGetBuyerKPIsError({ error: data.errores }))
    }

    const { data: buyerKPIs } = data.payload.find(item => item.year === payload.year) || {}

    return dispatch(
      onGetBuyerKPIsSuccess({
        amount: buyerKPIs?.amount,
        biddings: buyerKPIs?.biddings,
        entCode: buyerKPIs?.entCode,
        month: buyerKPIs?.month,
        monthNumber: buyerKPIs?.monthNumber,
        name: buyerKPIs?.name,
        orders: buyerKPIs?.orders,
        percentAmountAcumCLP: buyerKPIs?.percentAmountAcumCLP,
        percentAmountMonthCLP: buyerKPIs?.percentAmountMonthCLP,
        totalAmount: buyerKPIs?.totalAmount
      })
    )
  } catch (error) {
    return dispatch(onGetBuyerKPIsError({ error }))
  }
}
